export default "__VITE_ASSET__CXuyWViR__"